<div [formGroup]="formGroup">
  <h4 class="font-medium text-base mb-3">Seuils</h4>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label for="alertThreshold" class="font-medium">Seuil d'alerte</label>
      <p-inputnumber
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        formControlName="alertThreshold"
        class="w-full min-w-0 mt-2 relative"
        [showButtons]="true"
        [step]="0.1"
        mode="decimal"
        placeholder="Ex: 4"
        [minFractionDigits]="2"
        [ngClass]="{ 'ng-invalid-border': getFieldError('alertThreshold') }"
      />
      <small
        *ngIf="getFieldError('alertThreshold')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("alertThreshold") }}</small
      >
    </div>

    <div>
      <label for="toleranceThreshold" class="font-medium"
        >Seuil de tolérance</label
      >
      <p-inputnumber
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        formControlName="toleranceThreshold"
        class="w-full min-w-0 mt-2 relative"
        [showButtons]="true"
        [step]="0.1"
        mode="decimal"
        placeholder="Ex: 4"
        [minFractionDigits]="2"
        [ngClass]="{ 'ng-invalid-border': getFieldError('toleranceThreshold') }"
      />
      <small
        *ngIf="getFieldError('toleranceThreshold')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("toleranceThreshold") }}</small
      >
    </div>

    <div>
      <label for="minAlertThreshold" class="font-medium"
        >Seuil d'alerte minimal</label
      >
      <p-inputnumber
        formControlName="minAlertThreshold"
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        class="w-full min-w-0 mt-2 relative"
        [showButtons]="true"
        [step]="0.1"
        mode="decimal"
        placeholder="Ex: 2"
        [minFractionDigits]="2"
        [ngClass]="{ 'ng-invalid-border': getFieldError('minAlertThreshold') }"
      />
      <small
        *ngIf="getFieldError('minAlertThreshold')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("minAlertThreshold") }}</small
      >
    </div>

    <div>
      <label for="minToleranceThreshold" class="font-medium"
        >Seuil de tolérance minimal</label
      >
      <p-inputnumber
        formControlName="minToleranceThreshold"
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        class="w-full min-w-0 mt-2 relative"
        [showButtons]="true"
        [step]="0.1"
        mode="decimal"
        placeholder="Ex: 2"
        [minFractionDigits]="2"
        [ngClass]="{
          'ng-invalid-border': getFieldError('minToleranceThreshold'),
        }"
      />
      <small
        *ngIf="getFieldError('minToleranceThreshold')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("minToleranceThreshold") }}</small
      >
    </div>
  </div>
</div>
